/** localStorage for per-visitor conveniences only (theme, language, cached branding). Never throws. */
export const safeStorage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(`mc.${key}`);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(`mc.${key}`, value);
    } catch {
      // Private mode or blocked storage: the preference just isn't remembered.
    }
  },
  remove(key: string): void {
    try {
      window.localStorage.removeItem(`mc.${key}`);
    } catch {
      // Same as above.
    }
  },
};
